import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function RiskReversal() {
  return <section className="py-10 md:py-24 bg-charcoal-dark border-y border-charcoal-light relative overflow-hidden" data-id="element-280">
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber/5 rounded-full blur-3xl pointer-events-none" data-id="element-281"></div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-282">
        <FadeIn data-id="element-283">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-charcoal border border-amber/30 mb-8" data-id="element-284">
            <ShieldCheckIcon className="w-8 h-8 text-amber" data-id="element-285" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8" data-id="element-286">
            Garantía de Coherencia
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} className="space-y-6 text-lg text-offwhite-dim" data-id="element-287">
          <p className="text-xl font-medium text-sand" data-id="element-288">
            Si en 7 días no sentís más claridad y control: no seguís. Y listo.
          </p>
          <p className="text-offwhite font-bold" data-id="element-289">
            Sin formularios. Sin explicaciones.
          </p>
        </FadeIn>
      </div>
    </section>;
}